<script setup lang="ts">
// PROPS
interface Props {
    as?: string;
}

const { as = 'div' } = defineProps<Props>();
</script>

<template>
    <UContainer :as="as">
        <slot />
    </UContainer>
</template>
